import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78df5aef"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"position":"relative"} }
const _hoisted_2 = { style: {"position":"absolute","height":"14px","width":"100%","z-index":"10"} }
const _hoisted_3 = { class: "drag" }
const _hoisted_4 = { class: "checkbox" }
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "icon" }

import {ref} from 'vue';
import {DataNode} from '@/components/common/tree/TreeUtil';
import ScBtn from '@/components/common/widget/ScBtn.vue';
import ScDrop from '@/components/common/drag/ScDrop';
import ScDrag from '@/components/common/drag/ScDrag';


export default /*#__PURE__*/_defineComponent({
  __name: 'MenuNode',
  props: {
    node: {},
    menu: { default: () => ([] as Array<{ title: string; handler: () => void }>) }
  },
  emits: ["data", "add", "move"],
  setup(__props: any) {





const hoverBefore = ref(false)
const line = ref(null)


return (_ctx: any,_cache: any) => {
  const _component_sc_icon = _resolveComponent("sc-icon")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_input = _resolveComponent("a-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(ScDrop), {
      accept: "node",
      onDrop: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('move', [$event, _ctx.node, 'before']))),
      modelValue: hoverBefore.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((hoverBefore).value = $event))
    }, {
      default: _withCtx(({ dragging }) => [
        _withDirectives(_createElementVNode("div", _hoisted_2, null, 512), [
          [_vShow, dragging]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_unref(ScDrop), {
      accept: "node",
      onDrop: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('move', [$event, _ctx.node, 'inside'])))
    }, {
      default: _withCtx(({ hover }) => [
        _createElementVNode("div", {
          class: _normalizeClass(["line", { active: _ctx.node.selected }]),
          style: _normalizeStyle({ paddingLeft: _ctx.node.level * 22 + 'px' }),
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.node.select(!_ctx.node.selected))),
          ref_key: "line",
          ref: line
        }, [
          _createElementVNode("span", {
            class: "arrow",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.node.setOpen(!_ctx.node.opened)))
          }, [
            _withDirectives(_createVNode(_component_sc_icon, {
              type: _ctx.node.opened ? 'CaretRightOutlined' : 'CaretDownOutlined'
            }, null, 8, ["type"]), [
              [_vShow, _ctx.node.children.length > 0]
            ])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["line-content", { hover, hoverBefore: hoverBefore.value }])
          }, [
            _createVNode(_unref(ScDrag), {
              format: "node",
              data: _ctx.node.id,
              img: { el: line.value }
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_3, [
                  _createVNode(_component_sc_icon, { type: "HolderOutlined" })
                ])
              ]),
              _: 1
            }, 8, ["data", "img"]),
            _createElementVNode("span", _hoisted_4, [
              _createVNode(_component_a_checkbox, {
                checked: _ctx.node.checked === 'yes',
                indeterminate: _ctx.node.checked === 'half',
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.node.check(_ctx.node.checked !== 'yes')))
              }, null, 8, ["checked", "indeterminate"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, [
                _createVNode(_component_sc_icon, {
                  type: _ctx.node.data.class
                }, null, 8, ["type"])
              ]),
              _createVNode(_component_a_input, {
                class: "class",
                size: "small",
                value: _ctx.node.data.class,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('data', { class: $event })))
              }, null, 8, ["value"]),
              _createVNode(_component_a_input, {
                class: "title",
                size: "small",
                value: _ctx.node.data.title,
                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('data', { title: $event })))
              }, null, 8, ["value"]),
              (_ctx.node.level > 0 && _ctx.node.children.length === 0)
                ? (_openBlock(), _createBlock(_component_a_input, {
                    key: 0,
                    class: "path",
                    size: "small",
                    style: {"margin-right":"10px"},
                    value: _ctx.node.data.path,
                    "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('data', { path: $event })))
                  }, null, 8, ["value"]))
                : _createCommentVNode("", true),
              (_ctx.node.level !== 2)
                ? (_openBlock(), _createBlock(ScBtn, {
                    key: 1,
                    text: "add",
                    size: "small",
                    style: {"margin-right":"10px"},
                    handler: () => _ctx.$emit('add')
                  }, null, 8, ["handler"]))
                : _createCommentVNode("", true),
              _createVNode(ScBtn, {
                text: "del",
                size: "small",
                type: "danger",
                confirm: "确定",
                handler: () => _ctx.node.del(),
                style: {"margin-right":"10px"}
              }, null, 8, ["handler"])
            ])
          ], 2)
        ], 6)
      ]),
      _: 1
    })
  ]))
}
}

})